import React from 'react'
import {
  Row,
  Col,
  Button
} from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import logo from "../assets/images/logo.png"
import { useAuth } from "../contexts/AuthContext"

const Page403 = () => {
  const { logout } = useAuth()

  return (
    <Row justify="center" align="middle" className="auth-container">
      <Col span={24}>
        <Row justify="center">
          <Col span={24} className="logo-container">
            <img src={logo} alt="" className="auth-logo" />
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Col span={24} lg={{ span: 7 }}>
                <div className="form-container">
                  <div className="form-header">
                    <WarningOutlined style={{ fontSize: "10em" }} />
                    <h1>403 Not Authorized</h1>
                    <p>You are not authorized to get access of this portal.</p>
                    <span className=" ant-btn-lg">
                      <Button type="primary" onClick={() => logout("/auth/login")} size="large">Log Out</Button>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Page403
